<template>
  <div
    :class="b()"
  >
    <el-input
      ref="addTodoInputFocus"
      v-model="form.name"
      v-el-input-auto-padding="5"
      type="textarea"
      :class="b('textarea')"
      :maxlength="$inputLimit.issueSummary"
      show-word-limit
      :rows="2"
      :placeholder="$t('home.todo.addTodoTitle')"
      @keypress.enter.native.prevent="save"
    >
    </el-input>
    <div :class="b('button-container')">
      <div :class="b('button-container-left')">
        <el-popover
          :popper-class="b('todo-status')"
          trigger="click"
          placement="bottom-start"
        >
          <ul
            :class="b('status-list')"
          >
            <template v-if="showStateList">
              <li
                :class="b('status-loading')"
              >
                <em class="el-icon-loading"></em>
              </li>
            </template>
            <template v-else>
              <li
                v-for="item in stateOptions"
                :key="item.categoryId"
              >
                <div
                  v-overflow-tooltip="item.categoryName"
                  :class="[b('status-item'), 'text-ellipsis']"
                  @click="handleChangeStatus(item)"
                >
                  {{ item.categoryName }}
                </div>
                <el-divider v-if="item.lastOne"></el-divider>
              </li>
              <li
                v-if="!showStateList && stateOptions.length === 0"
                :class="[b('status-placeholder')]"
              >
                <span>{{ $t('home.todo.noStatusChange') }}</span>
              </li>
            </template>
          </ul>

          <div
            slot="reference"
            :class="b('status-container')"
          >
            <div
              :class="b('dropdown-status')"
            >
            </div>
            <el-tooltip
              :content="`${$t('home.todo.status')}: ${status.categoryName}`"
              placement="bottom"
            >
              <div
                :class="[b('status-name'), b(`status-font-${status.categoryId}`), 'click-cursor']"
              >
                {{ status.categoryName }}
              </div>
            </el-tooltip>
          </div>
        </el-popover>
        <el-tooltip
          :content="`${$t('home.todo.priority')} : ${
            priority.name || $t('home.todo.unset')
          }`"
        >
          <ProrityDropdown
            :class="b('prority-container')"
            :value="priority.id"
            :default-color="priority.color"
            :prioritys="priorityOptions"
            @change="onChangePriority"
          />
        </el-tooltip>
        <el-tooltip
          :content="`${$t('home.todo.dueDate')}`"
          placement="bottom"
        >
          <ZkDueDate
            v-model="form.dueDate"
            clearable
            clear-fixed
            :class="b('date')"
            type="datetime"
            default-time="18:00:00"
            :format="$i18n.dateFormat.dateTime"
            :empty-text="''"
            :cleartext="$t('button.clear')"
            :picker-options="pickerConfig()"
            @change="onChangeDueDate"
          >
            <template #text>
              <span
                v-if="form.dueDate"
                :class="b('due-time')"
              >
                <span>
                  {{ form.dueDate | formatCalendarDate({ sameDay: '[today] HH:mm' }) }}
                </span>
              </span>
            </template>
          </ZkDueDate>
        </el-tooltip>
        <span
          :class="b('open-dialog')"
          @click="handleOpenTodoDialog"
        >
          <el-tooltip
            :content="`${$t('home.todo.expandDialog')}`"
            placement="bottom"
          >
            <em class="zkicon iconzhankai1" />
          </el-tooltip>
        </span>
      </div>
      <div :class="b('button-container-right')">
        <el-button
          size="mini"
          @click="cancel"
        >
          {{ $t('button.cancel') }}
        </el-button>
        <el-button
          type="primary"
          size="mini"
          :loading="addTodoLoading.loading"
          @click="addTodoLoading.fn"
        >
          {{ $t('button.add') }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import theme from '@zk/theme/lib/variables.scss';
import { createLoadingEvent } from '@zk/framework-vue';
import {
  getTodoPriorityList,
  getListStateCategory,
  addTodo
} from '@/api/home';
import dayjs from 'dayjs';
import ZkDueDate from 'common-module/src/components/DueDate';


export default {
  name: 'AddTodoInput',
  components:{
    ZkDueDate
  },
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bemNS: theme.bemNS,
      addTodoLoading: createLoadingEvent(this.save),
      form: {
        name: '',
        status: 2,
        priority: null,
        dueDate: null
      },
      priorityOptions: [],
      stateOptions: [],
      showStateList: false
    };
  },
  computed: {
    dialogTitle() {
      return this.id ? this.$t('home.todo.editTodo') : this.$t('home.todo.addTodo');
    },
    dialogBtn() {
      return this.id ? this.$t('button.save') : this.$t('button.addTo');
    },
    priority() {
      return this.priorityOptions?.find(item => item.id === this.form.priority) || {};
    },
    status() {
      return this.stateOptions?.find(item => item.categoryId === this.form.status) || {};
    },
    rules() {
      return {
        name: [
          { required: true, message: this.$t('home.todo.input'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('home.todo.select'), trigger: 'change' }
        ]
      };
    }
  },
  async created() {
    const list = await getTodoPriorityList();
    this.priorityOptions = [
      {
        id: null,
        name: this.$t('home.todo.wu'),
        color: '#d7d7d7'
      },
      ...list
    ];
    this.stateOptions = await getListStateCategory();
    this.form.priority = this.priorityOptions[0].id;
  },
  methods: {
    addTodoInputFocus () {
      this.$refs.addTodoInputFocus.focus();
    },
    async save() {
      if (!this.form.name) {
        this.$message.warning(this.$t('home.todo.inputTitle'));
        return;
      }

      const p = { ...this.form };
      await addTodo(p);
      this.resetForm();
      this.$message.success(this.$t('message.addToSuccess'));
      this.$emit('submit');
      this.$track.send('TodoList_AddTodo', {}, true);
    },
    cancel() {
      this.resetForm();
      this.$emit('cancel');
    },
    resetForm () {
      this.form = {
        name: '',
        status: 2,
        priority: null,
        dueDate: null
      };
    },
    handleOpenTodoDialog() {
      const form = { ...this.form };
      this.resetForm();
      this.$emit('show:todoDialog', form);
    },
    onChangeDueDate(val) {
      this.form.dueDate = val;
    },
    handleChangeStatus(item) {
      this.form.status = item.categoryId;
    },
    onChangePriority(v) {
      this.form.priority = v;
    },
    dayFormat(date) {
      return dayjs(date).isValid() ? dayjs(date).format('HH:mm:ss') : null;
    },
    /* 截止时间禁选配置 */
    pickerConfig() {
      const MAX_TIME = '23:59:59';
      const MIN_TIME = '00:00:00';
      const minTime = this.dayFormat(new Date()) || MIN_TIME;
      const isSameDay = dayjs(this.form.dueDate).isSame(dayjs(new Date()), 'day');
      const startDateVo = minTime !== MIN_TIME ? dayjs(new Date()).subtract(1, 'day') : new Date();
      return {
        disabledDate: time => dayjs(time).isBefore(startDateVo),
        selectableRange: isSameDay ? `${minTime} - ${MAX_TIME}` : []
      };
    },
    setDefaultTime() {
      this.form.dueDate = new Date(new Date().getTime()).setHours(18, 0, 0, 0);
    }
  }
};
</script>

<style lang="scss" scoped>
@include b(add-todo-input) {
  width: 100%;
  position: relative;
  margin-top: 15px;
  margin-bottom: 10px;
  min-height: 100px;
  @include e(textarea) {}
  @include e(button-container) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    bottom: 5px;
    left: 0px;

    background: var(--main-bg-color);
    height: 40px;
    width: calc(100% - 20px);
    margin: 0 10px 0 10px;
    padding: 0 10px 0 0;
    z-index: 10;
  }
  @include e(date) {
    margin-right:  var(--m-small);
    min-width: auto;
  }
  @include e(due-time) {
    display: flex;
    align-items: center;
    .zkicon {
      margin-right: var(--m-mini);
    }
  }
  @include e(open-dialog) {
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin-left: var(--m-small);
    .zkicon {
      font-size: var(--size-font-5);
    }
  }
  @include e(status-name) {
    font-size: var(--size-font-9);
    margin: 0 20px 0 10px;
    padding: 0 6px;
    height: 20px;
    line-height: 20px;
    border-radius: 10px;
    min-width: 36px;
    max-width: 80px;
  }
  @include e(status-font-2) {
    margin-left: 2px;
    color: $state-none-color;
    background: $state-none-bg;
  }
  @include e(prority-container) {
    margin-right: 20px;
  }
  @include e(status-font-3) {
    margin-left: 2px;
    // color: $state-progress-color;
    // background: $state-progress-bg;
    color: var(--state-doing-color-1);
    background: var(--state-doing-bg);
  }
  @include e(status-font-4) {
    margin-left: 2px;
    color: $state-completed-color;
    background: $state-completed-bg;
  }
  @include e(button-container-left) {
    display: flex;
    align-items: center;
  }
  @include e(button-container-right) {

  }
  ::v-deep {
    .el-textarea .el-textarea__inner {
      height: 100px;
      padding-bottom: 40px;
    }
    .el-textarea .el-input__count {
      bottom: 50px;
      right: 20px;
    }
  }
}
</style>
<style lang="scss">
.zk-add-todo-input__todo-status {
  padding: 10px 0;
  max-width: 88px;
  .zk-add-todo-input__status-list {
    margin: 0;
    padding: 0;
    list-style: none;
    .zk-add-todo-input__status-loading {
      font-size: var(--size-font-5);
      line-height: 40px;
      text-align: center;
    }
    .zk-add-todo-input__status-placeholder {
      text-align: center;
    }
    .el-divider.el-divider--horizontal {
      margin: 10px 0;
      background: #EEEEEE;
    }
  }
  .zk-add-todo-input__status-item {
    margin: 0;
    padding: 8px 16px;
    cursor: pointer;
  }
  .zk-add-todo-input__status-item:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
}
</style>
